export const INIT_GENERATE_FINGERPRINT =
  'productDiscovery/fingerprint/INIT_GENERATE_FINGERPRINT';
export const SET_FINGERPRINT = 'productDiscovery/fingerprint/SET_FINGERPRINT';
export const SET_FINGERPRINT_FAILED =
  'productDiscovery/fingerprint/SET_FINGERPRINT_FAILED';

export interface GenerateFingerprint {
  type: typeof INIT_GENERATE_FINGERPRINT;
}

export const initGenerateFingerprint = (): GenerateFingerprint => ({
  type: INIT_GENERATE_FINGERPRINT,
});

export interface SetFingerprint {
  type: typeof SET_FINGERPRINT;
  fingerprint: string | null;
}

export const setFingerprint = (fingerprint: string | null): SetFingerprint => ({
  type: SET_FINGERPRINT,
  fingerprint,
});

export interface SetFingerprintFailed {
  type: typeof SET_FINGERPRINT_FAILED;
  error: string;
}

export const setFingerprintFailed = (error: string): SetFingerprintFailed => ({
  type: SET_FINGERPRINT_FAILED,
  error,
});

export type Action =
  | GenerateFingerprint
  | SetFingerprint
  | SetFingerprintFailed;
